/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable array-callback-return */
const PostalDataForm = () =>
    import(/* webpackChunkName: "PostalData" */ '@/components/interveners/postal-data/postal-data-form');

import countriesOptions from '@/mixins/countriesOptions';
import formatData from '@/mixins/formatData';
import keyed from '@/mixins/keyed';
import statesOptions from '@/mixins/statesOptions';
import streetTypesOptions from '@/mixins/streetTypesOptions';
import Validations from '@/mixins/validations';
// import uuidv4 from 'uuid/v4';

export default {
    /**
     * Nombre del componente
     */
    name: 'PostalData',

    mixins: [countriesOptions, statesOptions, streetTypesOptions, formatData, keyed, Validations],

    components: {
        PostalDataForm
    },

    watch: {
        formattedData: {
            handler() {
                this.keyUpdate++;
            },
            deep: true
        }
    },

    /**
     * Datos del componente
     * @return {Object} Data del componente
     */
    data() {
        return {
            collapsed: true,
            postalRadioButton: null,
            addressesTable: null,
            postalAddressCreate: false,
            keyUpdate: 0,
            address: '',
            selectedAddress: ''
        };
    },

    /**
     * Variables que vienen del componente padre
     */
    props: {
        /**
         * Identificador del interviniente
         */
        uuid: {
            type: String,
            required: false
        },
        /**
         * Información de postal_address
         */
        data: {
            type: Object
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        existing: {
            type: Boolean,
            required: false,
            default: false
        },
        hideActions: {
            type: Boolean,
            required: false,
            default: false
        },
        isModal: {
            type: Boolean,
            required: false,
            default: false
        },
        intervenerStatus: {
            type: String,
            required: false,
            default: ''
        },
        isContributor: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    methods: {
        // Google Maps Autocomplete function
        async getAddressData(addressData, placeResultData) {
            this.address = addressData;
            const completeAddress = placeResultData.address_components.reverse();
            let state;
            // Clear fields
            this.formattedData.street_1 = undefined;
            this.formattedData.number = undefined;
            this.formattedData.floor = undefined;
            this.formattedData.door = undefined;
            this.formattedData.street_2 = undefined;
            this.formattedData.postal_code = undefined;
            this.formattedData.country = undefined;
            this.formattedData.state = undefined;
            this.formattedData.city = undefined;
            // Assign search result to form fields
            completeAddress.map(ad => {
                if (ad.types.includes('route')) {
                    this.modifiedData['street_1'] = ad.long_name;
                    this.formattedData.street_1 = ad.long_name;
                }
                if (ad.types.includes('street_number')) {
                    this.modifiedData['number'] = ad.long_name;
                    this.formattedData.number = ad.long_name;
                }
                if (ad.types.includes('postal_code')) {
                    this.modifiedData['postal_code'] = ad.long_name;
                    this.formattedData.postal_code = ad.long_name;
                }
                if (ad.types.includes('locality') || ad.types.includes('postal_town')) {
                    this.modifiedData['city'] = ad.long_name;
                    this.formattedData.city = ad.long_name;
                }
                if (ad.types.includes('country')) {
                    if (ad.long_name === 'Spain') {
                        ad.long_name = 'España';
                    }
                    this.countriesOptions.map(co => {
                        if (co.name.includes(ad.long_name)) {
                            this.modifiedData['state'] = undefined;
                            this.modifiedData['key_state'] = undefined;
                            this.modifiedData['key_country'] = co.key;
                            this.formattedData.country = co;
                        }
                    });
                }
                if (ad.types.includes('administrative_area_level_2')) {
                    state = { key: ad.short_name, name: ad.long_name };
                } else if (
                    state === undefined &&
                    (ad.types.includes('administrative_area_level_1') || ad.types.includes('neighborhood'))
                ) {
                    state = { key: ad.short_name, name: ad.long_name };
                } else if (state === undefined && ad.types.includes('postal_town')) {
                    state = { key: ad.short_name, name: ad.long_name };
                }
            });
            await this.loadStatesOptions(this.formattedData.country.key);
            if (state !== undefined) {
                this.statesOptions.map(po => {
                    if (po.name.includes(state.name)) {
                        this.modifiedData['state'] = po.name;
                        this.modifiedData['key_state'] = po.key;
                        this.formattedData.state = po;
                        this.keyUpdate++;
                    }
                });
            }
        },
        /**
         * Función genérica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         */
        setValueEdited(field, val) {
            switch (field) {
                case 'state':
                    this.modifiedData['state'] = val.name;
                    this.modifiedData['key_state'] = val.key;
                    break;
                case 'key_country':
                    if (this.formattedData.state) {
                        this.formattedData.state = undefined;
                    }
                    this.modifiedData['key_country'] = val.key;
                    this.modifiedData['state'] = undefined;
                    this.modifiedData['key_state'] = undefined;
                    this.loadStatesOptions(val.key);
                    break;
                default:
                    this.modifiedData[field] = typeof val === 'object' ? val.key : val;
                    break;
            }
            this.keyUpdate++;
        },
        /**
         * Cuando postalRadioButton cambie de valor guardamos la nueva dirección seleccionada
         * en la base de datos.
         * @param {String} v Url de la dirección postal
         */
        changeAddress(v) {
            const payload = {
                _links: {
                    postal_address: v
                }
            };
            this.$intervenersService
                .updateIntervenerInfo(this.uuid, payload)
                .then(res => {
                    this.$emit('saved', res.data.intervener);
                    this.$toast.success(`Guardado`, `Datos modificados con éxito.`);
                })
                .catch(err => {
                    this.$toast.error(err.name, err.message);
                });
        },

        /**
         * OBTENEMOS LISTA DIRECCIONES
         * OBtenemos las direcciones del interviniente y buscamos cuál es la dirección activa para
         * poner el radiobutton correspondiente seleccionado en la tabla.
         */
        getAddresses() {
            if (!this.uuid) {
                return;
            }
            this.$intervenersService.getAddresses(this.uuid).then(res => {
                this.addressesTable.items = res.data.interveners_addresses;
                const postalAddressSelected = this.addressesTable.items.find(x => x.is_selected);
                if (postalAddressSelected) {
                    this.postalRadioButton =
                        postalAddressSelected._links &&
                        postalAddressSelected._links._self &&
                        postalAddressSelected._links._self.href
                            ? postalAddressSelected._links._self.href
                            : null;
                }
            });
        },

        /**
         * @param {*} row Dirección postal
         */
        onCanceledAddress(row) {
            row.toggleDetails();
        },

        /**
         * @param {*} row Dirección postal
         * @param {*} $event Evento
         */
        onSavedAddress(row, $event) {
            row.item = Object.assign(row.item, $event);
            row.toggleDetails();
        },

        /**
         * Añade una nueva dirección postal
         * @param {*} $event Evento
         */
        createNewAddress($event) {
            $event.preventDefault();
            $event.stopPropagation();
            this.postalAddressCreate = true;
        },

        /**
         * @override
         */
        cancelAddress() {
            this.modifiedData = {};
            this.formattedData = {};
            this.formatData();
            this.postalAddressCreate = false;
        },

        /**
         * Validaciones
         * @return {Boolean} valid or not
         */
        validateAddressData() {
            this.cleanErrors();

            const requiredProperties = ['street_1', 'postal_code', 'city', 'country'];

            return Promise.resolve(true).then(valid => this.validateRequired(requiredProperties, valid));
        },

        /**
         * Validaciones
         * @return {Boolean} valid or not
         */
        validateData() {
            this.cleanErrors();

            return Promise.resolve(true).then(valid => this.addressesTable.items.length > 0 && valid);
        },

        /**
         * Obtiene los datos pasando por la validación.
         * @return {*} `undefined` si no son validos
         */
        fetchValidatedData() {
            return this.validateData().then(valid => {
                return valid ? this.addressesTable.items.map(x => Object.assign({}, x)) : undefined;
            });
        },

        /**
         * @override
         */
        submitAddress() {
            const address = Object.assign({}, this.modifiedData);
            this.validateAddressData()
                .then(valid => {
                    if (!valid) {
                        throw new Error();
                    }
                    Promise.resolve(this.creation)
                        .then(isCreation => {
                            return !isCreation
                                ? this.$intervenersService.createIntervenerAddress(this.uuid, address).then(res => {
                                      this.$toast.success(
                                          `Guardado`,
                                          `Se ha añadido una nueva dirección postal al interviniente.`
                                      );
                                      return res.data.intervener_address;
                                  })
                                : address;
                        })
                        .then(addr => {
                            this.postalAddressCreate = false;
                            this.$emit('saved', addr);
                            this.$root.$emit('refresh_intervener');
                            this.addressesTable.items.push(addr);
                            this.modifiedData = {};
                            this.formattedData = {};
                            this.formatData();
                        })
                        .catch(err => {
                            this.$toast.error(err.name, err.message);
                            this.formatData();
                        });
                })
                .catch(() => {
                    this.$toast.error(
                        '[DIRECCIÓN POSTAL] Error en el formulario',
                        'Revisa los campos marcados en rojo'
                    );
                });
        },

        /**
         * @override
         */
        removeAddress(row) {
            if (this.creation) {
                this.addressesTable.items.splice(row.index, 1);
                if (this.addressesTable.items.length < 1) {
                    this.$store.dispatch('accountsStore/copyFiscalAddress', true);
                }
            } else {
                this.$intervenersService
                    .removeIntervenerAddress(this.uuid, row.item.uuid)
                    .then(() => {
                        this.$toast.success(`Guardado`, `La dirección se ha eliminado correctamente.`);
                        this.addressesTable.items.splice(row.index, 1);
                    })
                    .catch(err => {
                        this.$toast.error(err.name, err.message);
                    });
            }
        }
    },

    /**
     * @override
     */
    beforeMount() {
        this.$store.dispatch('accountsStore/copyFiscalAddress', true);
        this.addressesTable = {
            fields: [
                {
                    key: 'details',
                    label: ' '
                },
                {
                    key: 'radiobutton',
                    label: ' '
                },
                {
                    key: 'street_1',
                    label: 'Domicilio 1'
                },
                {
                    key: 'street_2',
                    label: 'Información adicional'
                },
                {
                    key: 'number',
                    label: 'Número'
                },
                {
                    key: 'floor',
                    label: 'Planta'
                },
                {
                    key: 'door',
                    label: 'Puerta'
                },
                {
                    key: 'postal_code',
                    label: 'Código postal'
                },
                {
                    key: 'city',
                    label: 'Localidad'
                },
                {
                    key: 'state',
                    label: 'Provincia/Región'
                },
                {
                    key: 'country',
                    label: 'Pais'
                },
                {
                    key: 'remove',
                    label: ' '
                }
            ],
            items: []
        };
        this.getAddresses();
    }
};
